import { render, staticRenderFns } from "./OnlineAppointmentMessageTemplatePanel.vue?vue&type=template&id=0135be34&scoped=true"
import script from "./OnlineAppointmentMessageTemplatePanel.vue?vue&type=script&lang=js"
export * from "./OnlineAppointmentMessageTemplatePanel.vue?vue&type=script&lang=js"
import style0 from "./OnlineAppointmentMessageTemplatePanel.vue?vue&type=style&index=0&id=0135be34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0135be34",
  null
  
)

export default component.exports